import { Routes, Route } from 'react-router-dom';
import AdminDashboard from './AdminDashboard';
import CreateAuthor from './CreateAuthor';
import ManageAuthors from './ManageAuthors';
import EditAuthor from './EditAuthor';
import CreateBook from './CreateBook';
import ManageBooks from './ManageBooks';
import EditBook from './EditBook';
import CreateQuestion from './CreateQuestion';
import ManageQuestions from './ManageQuestions';
import EditQuestion from './EditQuestion';

function Admin() {
    return (
        <Routes>
            <Route path="/" element={<AdminDashboard />} />
            <Route path="/create-author" element={<CreateAuthor />} />
            <Route path="/manage-authors" element={<ManageAuthors />} />
            <Route path="/edit-author/:id" element={<EditAuthor />} />
            <Route path="/create-book" element={<CreateBook />} />
            <Route path="/manage-books" element={<ManageBooks />} />
            <Route path="/edit-book/:id" element={<EditBook />} />
            <Route path="/create-question" element={<CreateQuestion />} />
            <Route path="/manage-questions" element={<ManageQuestions />} />
            <Route path="/edit-question/:id" element={<EditQuestion />} />
            {/* Add more admin routes here as needed */}
        </Routes>
    );
}

export default Admin;
